import { display } from '../tools/display';
export function displayAlreadyInitializedError(sdkName, initConfiguration) {
    if (!initConfiguration.silentMultipleInit) {
        display.error(`${sdkName} is already initialized.`);
    }
}
//# sourceMappingURL=displayAlreadyInitializedError.js.map


// WEBPACK FOOTER //
// ./~/@datadog/browser-rum/~/@datadog/browser-core/esm/boot/displayAlreadyInitializedError.js